import React, { Component } from 'react';
import cn from 'classnames';
import input from './Input.module.scss';
import { ReactComponent as EyeIcon } from '../../styles/icon/eye.svg';
import { ReactComponent as EyeDefaultIcon } from '../../styles/icon/eye-default.svg';
import { ReactComponent as EyeDarkIcon } from '../../styles/icon/eye-dark.svg';
import { ReactComponent as EyeDarkDefaultIcon } from '../../styles/icon/eye-dark-default.svg';

class Input extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // inputValue: '',
      isFloatingLabel: false,
      currentType: props.type,
    };
  }

  activateFocus = (e) => {
    const { onFocus } = this.props;
    this.setState({
      isFloatingLabel: true,
    });
    if (onFocus) {
      onFocus(e);
    }
  };

  disableFocus = (e) => {
    const { onBlur } = this.props;
    if (e.target.value === '') {
      this.setState({
        isFloatingLabel: false,
      });
    }
    if (onBlur) {
      onBlur(e);
    }
  };

  // updateInputValue = (e) => {
  //   this.setState({
  //     inputValue: e.target.value,
  //   });
  //   this.activateFocus(e);
  //   e.preventDefault();
  // };

  handleChange = () => {
    this.setState((state) => {
      return {
        currentType: state.currentType === 'password' ? 'text' : 'password',
      };
    });
  };

  render() {
    const {
      className,
      inputClassName,
      labelClassName,
      secondaryClassName,
      thirdClassName,
      label,
      variant,
      name,
      id,
      autoComplete,
      placeholder,
      autoFocus,
      onChange,
      onClick,
      onClickInputValue,
      onKeyDown,
      error,
      helperText,
      value,
      disabled,
      readOnly,
      // onFocus,
      // onBlur,
      isTypeFieldPassword,
      isTypeFieldPasswordCredentials,
      refreshSecret,
      eventIcon,
      ...rest
    } = this.props;
    const { currentType } = this.state;
    const hasError = !!(error && helperText);

    return (
      <div
        className={cn(input.input__container, {
          [input[`${className}`]]: !!className,
        })}
      >
        {label && (
          <label
            className={cn(input.input__label, {
              [labelClassName]: !!labelClassName,
              [input['input__label--is-floating']]: this.state.isFloatingLabel || value,
            })}
            htmlFor={id}
          >
            {label}
          </label>
        )}
        <div
          className={cn(input.input__box, {
            [input['input__box--not-valid']]: hasError,
          })}
        >
          <input
            className={cn(input.input__textfield, {
              [input[`input_${variant}`]]: !!variant,
              [input[`${className}`]]: !!className,
              [input[`${secondaryClassName}`]]: !!secondaryClassName,
              [input[`${thirdClassName}`]]: !!thirdClassName,
              [inputClassName]: !!inputClassName,
            })}
            name={name}
            id={id}
            autoComplete={autoComplete}
            placeholder={placeholder}
            autoFocus={autoFocus}
            onChange={onChange}
            onKeyDown={onKeyDown}
            // value={this.state.inputValue}
            value={value}
            onClick={onClickInputValue}
            disabled={disabled}
            readOnly={readOnly}
            onFocus={this.activateFocus}
            onBlur={this.disableFocus}
            // onChange={this.updateInputValue}
            {...rest}
            type={currentType}
          />
          <div className={input.input__border} />
          {isTypeFieldPassword && (
            <button
              className={input.input__eye}
              onClick={this.handleChange}
            >
              {currentType === 'password' ? <EyeIcon /> : <EyeDefaultIcon />}
            </button>
          )}
          {isTypeFieldPasswordCredentials && (
            <div className={input.input__eye} onClick={this.handleChange}>
              {currentType === 'password' ? <EyeDarkIcon /> : <EyeDarkDefaultIcon />}
            </div>
          )}
          {refreshSecret && (
            <button className={input.input__refresh} onClick={onClick}>
              {refreshSecret}
            </button>
          )}
          {eventIcon && (
            <button
              className={cn(input.input__eye, {
                [input['input__eye--disabled']]: disabled,
              })}
              onClick={onClick}
            >
              {eventIcon}
            </button>
          )}
          {hasError && <p className={input.input__error}>{helperText}</p>}
        </div>
      </div>
    );
  }
}

export default Input;
